import { Controller } from "@hotwired/stimulus"

// Conditional-detail pattern from the client's reference forms: a radio group ("Ja/Nein",
// "Studio/Vor Ort") reveals its detail block while the radio matching `onValue` is selected.
// Hidden details are CLEARED (not just hidden), so a value entered and then toggled away never
// submits — the server prunes these again in brief_from, but this keeps the UI honest too.
export default class extends Controller {
  static targets = ["trigger", "detail"]
  static values = { on: String }

  connect() { this.toggle() }

  toggle() {
    const selected = this.triggerTargets.find((r) => r.checked)?.value
    const show = selected === this.onValue
    this.detailTargets.forEach((detail) => {
      detail.hidden = !show
      if (show) return
      detail.querySelectorAll("input, textarea, select").forEach((el) => {
        if (el.type === "radio" || el.type === "checkbox") el.checked = false
        else el.value = ""
      })
    })
  }
}
